module.exports = __webpack_public_path__ + "img/global-1997-moscow.be7130a9.jpg";